
export const geo = {

  // Location-related properties
  location: {
    latitude: null,
    longitude: null,
    useTempPosition: false,
    tempLatitude: null,
    tempLongitude: null
  },

  // Get current position - returns either actual or temporary position
  getCurrentPosition() {
    if (this.location.useTempPosition && this.location.tempLatitude && this.location.tempLongitude) {
      return {
        latitude: this.location.tempLatitude,
        longitude: this.location.tempLongitude
      };
    }
    return {
      latitude: this.location.latitude,
      longitude: this.location.longitude
    };
  },

  // Set position from geolocation
  setPosition(position) {
    this.location.latitude = position.coords.latitude;
    this.location.longitude = position.coords.longitude;
    // Store in localStorage for persistence
    localStorage.setItem('userLocation', JSON.stringify({
      latitude: this.location.latitude,
      longitude: this.location.longitude
    }));
    return this.getCurrentPosition();
  },

  // Set a temporary position manually
  setTempPosition(latitude, longitude) {
    this.location.tempLatitude = latitude;
    this.location.tempLongitude = longitude;
    this.location.useTempPosition = true;
    // Store temp position in localStorage
    localStorage.setItem('tempLocation', JSON.stringify({
      latitude,
      longitude,
      useTempPosition: true
    }));
    return this.getCurrentPosition();
  },

  // Stop using temporary position and revert to actual position
  clearTempPosition() {
    this.location.useTempPosition = false;
    localStorage.removeItem('tempLocation');
    return this.getCurrentPosition();
  },

  // Get the user's geolocation
  getLocation() {
    // First check if we have stored location
    const storedLocation = localStorage.getItem('userLocation');
    const storedTempLocation = localStorage.getItem('tempLocation');
    
    if (storedLocation) {
      const parsedLocation = JSON.parse(storedLocation);
      this.location.latitude = parsedLocation.latitude;
      this.location.longitude = parsedLocation.longitude;
    }
    
    if (storedTempLocation) {
      const parsedTemp = JSON.parse(storedTempLocation);
      this.location.tempLatitude = parsedTemp.latitude;
      this.location.tempLongitude = parsedTemp.longitude;
      this.location.useTempPosition = parsedTemp.useTempPosition;
    }

    // Then try to get current location
    if (this.isGeolocationAvailable()) {
      navigator.geolocation.getCurrentPosition(
        (position) => this.setPosition(position),
        (error) => {
          console.error('Geolocation error:', error);
          switch (error.code) {
            case error.PERMISSION_DENIED:
              console.warn("User denied the request for Geolocation.");
              break;
            case error.POSITION_UNAVAILABLE:
              console.warn("Location information is unavailable.");
              break;
            case error.TIMEOUT:
              console.warn("The request to get user location timed out.");
              break;
            case error.UNKNOWN_ERROR:
              console.warn("An unknown error occurred.");
              break;
          }
        }
      );
    } else {
      console.warn("Geolocation is not supported by this browser.");
    }
    
    return this.getCurrentPosition();
  },

  hasAllowedLocation() {
    // Returns true if the user has granted geolocation permission (not temp)
    //if (!navigator.permissions) return !!(this.location.latitude && this.location.longitude);
    return navigator.permissions.query({ name: 'geolocation' })
      .then(result => result.state === 'granted' && !!(this.location.latitude && this.location.longitude))
      .catch(() => !!(this.location.latitude && this.location.longitude));
  },

  // Add this utility function near the top of your auth object:
  isGeolocationAvailable() {
    return typeof navigator !== 'undefined' && !!navigator.geolocation;
  },

}

